import {
  BeginPurchaseResponseDto,
  ShopSubscriptionDto,
  SubscriptionRequestProductDto,
} from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class MarketFrontEndSubscriptionActions extends CaEntityActionsFactory<
  ShopSubscriptionDto,
  unknown,
  unknown,
  BaseFilterType
> {
  constructor() {
    super(`MarketFrontEndSubscriptions`);
  }

  clearSubscriptionFlowAction = createAction(`[${this.type}][Request] Clear Subscription Flow`);

  beginSubscriptionFlowAction = createAction(
    `[${this.type}][Request] Begin Subscription Flow`,
    props<{
      customerId: string;
      products: SubscriptionRequestProductDto[];
      paymentMethodId: string;
    }>(),
  );

  beginSubscriptionFlowSuccessAction = createAction(
    `[${this.type}][Response][Success] Begin Subscription Flow`,
    props<{
      customerId: string;
      products: SubscriptionRequestProductDto[];
      response: BeginPurchaseResponseDto;
    }>(),
  );

  beginSubscriptionFlowFailureAction = createAction(
    `[${this.type}][Response][Failure] Begin Subscription Flow`,
    props<{ error: any; products: SubscriptionRequestProductDto[] }>(),
  );

  subscriptionPaymentCompleteAction = createAction(
    `[${this.type}][Request] Subscription Payment Complete`,
    props<{ id: string }>(),
  );

  RequestCancelSubscriptionAction = createAction(
    `[${this.type}][Request] cancel subscription`,
    props<{ subscriptionId: string; reason: string }>(),
  );

  ResponseSuccessCancelSubscriptionAction = createAction(
    `[${this.type}][Response][Success] cancel subscription`,
    props<{ subscriptionId: string; subscription: ShopSubscriptionDto }>(),
  );

  ResponseFailCancelSubscriptionAction = createAction(
    `[${this.type}][Response][Fail] cancel subscription`,
    props<{ subscriptionId: string; error: any }>(),
  );

  // Requests all subscriptions for the current user
  requestMyAllForSegmentAction = createAction(
    `[${this.type}][Request] Request All Subscriptions For Myself For Segment`,
    props<{ segment: string; filter?: BaseFilterType; clear?: boolean }>(),
  );
}

export const MarketFrontEndSubscriptions = new MarketFrontEndSubscriptionActions();
